import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";

// Fetching Data from the API]

// End

// Page Html
export default function SingleAnswer() {
  const [singleAnswerData, setSingleAnswerData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSingleAnswerData = async () => {
      try {
        const response = await fetch("/api/questions/singleanswer", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setSingleAnswerData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch SingleAnswer data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching SingleAnswer data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchSingleAnswerData();
  }, []); // Empty dependency array to fetch data only once on mount

  // End

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Multiple Type Single Answer" id={singleAnswerData.data} />

    </div>
  );
}
